// @flow
import {
  GetSlaPerformanceTrendsDefaultReports,
  GetSlaPerformanceTrendsDefaultReportsSuccess,
  GetSlaPerformanceTrendsDefaultReportsError,
  GetSlaPerformanceTrendsMyReports,
  GetSlaPerformanceTrendsMyReportsSuccess,
  GetSlaPerformanceTrendsMyReportsError,
  GetSlaPerformanceTrendsReportData,
  GetSlaPerformanceTrendsReportDataSuccess,
  GetSlaPerformanceTrendsReportDataError,
  ToggleSlaPerformanceTrendsEditReportModal,
  UpdateSlaPerformanceTrendsReport,
  UpdateSlaPerformanceTrendsReportError,
} from "@modules/reporting/constants/actions";
import type { SlaPerformanceState } from "./types";
import { cloneObject } from "@utils/object";

export const initialState: SlaPerformanceState = {
  error: null,
  requestsInProgress: 0,
  defaultReports: [],
  myReports: [],
  report: {
    details: null,
    reportData: {
      complianceTrend: [],
      report: [],
    },
    canSave: false,
  },
  modals: {
    editReport: {
      visible: false,
    },
  },
};

export const setLoading = (state: SlaPerformanceState) => () => {
  return {
    ...state,
    requestsInProgress: ++state.requestsInProgress,
  };
};
export const onError = (state: SlaPerformanceState) => ({ payload }: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: payload,
  };
};

export const onGetSlaPerformanceTrendsDefaultReportsSuccess = (state: SlaPerformanceState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    error: null,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    defaultReports: payload,
  };
};

export const onGetSlaPerformanceTrendsMyReportsSuccess = (state: SlaPerformanceState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    error: null,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    myReports: payload,
  };
};

export const onGetSlaPerformanceTrendsReportDataSuccess = (state: SlaPerformanceState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    error: null,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    report: payload,
  };
};

export const onToggleSlaPerformanceTrendsEditReportModal = (state: SlaPerformanceState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    modals: {
      ...state.modals,
      editReport: payload,
    },
  };
};

export default (state: SlaPerformanceState = initialState, action: Object): SlaPerformanceState => {
  const act = {
    [GetSlaPerformanceTrendsDefaultReports]: setLoading,
    [GetSlaPerformanceTrendsDefaultReportsSuccess]: onGetSlaPerformanceTrendsDefaultReportsSuccess,
    [GetSlaPerformanceTrendsMyReports]: setLoading,
    [GetSlaPerformanceTrendsMyReportsSuccess]: onGetSlaPerformanceTrendsMyReportsSuccess,
    [GetSlaPerformanceTrendsReportData]: setLoading,
    [GetSlaPerformanceTrendsReportDataSuccess]: onGetSlaPerformanceTrendsReportDataSuccess,
    [UpdateSlaPerformanceTrendsReport]: setLoading,
    [GetSlaPerformanceTrendsDefaultReportsError]: onError,
    [GetSlaPerformanceTrendsMyReportsError]: onError,
    [GetSlaPerformanceTrendsReportDataError]: onError,
    [ToggleSlaPerformanceTrendsEditReportModal]: onToggleSlaPerformanceTrendsEditReportModal,
    [UpdateSlaPerformanceTrendsReportError]: onError,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
